import React from 'react';

const Logo = ({ size = 'default', showSubtitle = false, variant = 'dark', className = '' }) => {
  const sizes = {
    small: { icon: 28, text: 'text-base', subtitle: 'text-[8px]' },
    default: { icon: 34, text: 'text-xl', subtitle: 'text-[9px]' },
    large: { icon: 48, text: 'text-2xl', subtitle: 'text-xs' },
  };
  const s = sizes[size] || sizes.default;
  
  const colors = variant === 'light' 
    ? { primary: '#FFFFFF', accent: '#C67B5C', detail: '#8B9E8A', textClass: 'text-white', subtitleClass: 'text-white/60' }
    : { primary: '#1A3A52', accent: '#C67B5C', detail: '#8B9E8A', textClass: 'text-brand-primary', subtitleClass: 'text-text-muted' };

  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      {/* Book + Quill Icon */}
      <svg width={s.icon} height={s.icon} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Open book pages */}
        <path 
          d="M6 38V14C6 12 8 10 10 10H22C23 10 24 11 24 12V38C24 36 23 35 22 35H10C8 35 6 36 6 38Z" 
          fill={colors.accent} fillOpacity="0.2" stroke={colors.primary} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
        />
        <path 
          d="M42 38V14C42 12 40 10 38 10H26C25 10 24 11 24 12V38C24 36 25 35 26 35H38C40 35 42 36 42 38Z" 
          fill={colors.accent} fillOpacity="0.2" stroke={colors.primary} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
        />
        {/* Spine */}
        <line x1="24" y1="12" x2="24" y2="38" stroke={colors.primary} strokeWidth="1.5" />
        {/* Quill feather */}
        <path 
          d="M32 6C32 6 38 8 40 14C40 14 36 12 34 14C32 16 30 22 28 26L27 24C29 20 30 14 32 10C30 12 28 16 27 20L26 18C28 14 30 8 32 6Z" 
          fill={colors.primary} fillOpacity="0.85"
        />
        {/* Quill tip */}
        <line x1="28" y1="26" x2="26" y2="30" stroke={colors.primary} strokeWidth="1" strokeLinecap="round" />
        {/* Page lines */}
        <line x1="10" y1="17" x2="20" y2="17" stroke={colors.detail} strokeWidth="0.8" strokeLinecap="round" opacity="0.5" />
        <line x1="10" y1="21" x2="18" y2="21" stroke={colors.detail} strokeWidth="0.8" strokeLinecap="round" opacity="0.5" />
        <line x1="10" y1="25" x2="20" y2="25" stroke={colors.detail} strokeWidth="0.8" strokeLinecap="round" opacity="0.5" />
      </svg>
      
      {/* Text */}
      <div className="flex flex-col">
        <span className={`font-serif ${s.text} font-semibold ${colors.textClass} tracking-tight leading-tight`}>
          Collectively Write
        </span>
        {showSubtitle && (
          <span className={`${s.subtitle} uppercase tracking-[0.2em] ${colors.subtitleClass} font-medium`}>
            Literary Community
          </span>
        )}
      </div>
    </div>
  );
};

export default Logo;
